import { type UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { GetDuoByUserIdResponse } from 'generated/openapi';

import {
  type DuoDetailsKeyParams,
  getDuoDetailsKey,
  getDuoDetailsOptions,
} from './getDuoDetails.options';

export interface UseGetDuoDetailsProps<
  T = GetDuoByUserIdResponse,
> extends DuoDetailsKeyParams {
  options?: Omit<
    UseQueryOptions<GetDuoByUserIdResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetDuoDetails<T = GetDuoByUserIdResponse>({
  options,
  ...params
}: UseGetDuoDetailsProps<T>) {
  return useSuspenseQuery({
    ...getDuoDetailsOptions<T>(params),
    ...options,
  });
}

useGetDuoDetails.getQueryKey = getDuoDetailsKey;
